import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import AreasServices from "./areas.services";

export const getAreas = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_AREAS,
      payload: true,
    });
    const resp = await AreasServices.getAreas(filters);
    dispatch({
      type: actions.GET_AREAS,
      payload: resp.data,
    });
    dispatch({
      type: actions.AREAS_FAIL,
      payload: null,
    });
    dispatch({
      type: actions.FORM_AREA_FAIL,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.AREAS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_AREAS,
      payload: false,
    });
  }
};

export const getAreasDescFicha = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_AREAS_DESC,
      payload: true,
    });
    const resp = await AreasServices.getAreas(filters);
    dispatch({
      type: actions.GET_AREAS_DESC,
      payload: resp.data,
    });
    dispatch({
      type: actions.AREAS_FAIL,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.AREAS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_AREAS_DESC,
      payload: false,
    });
  }
};

export const getArea = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_AREA,
      payload: true,
    });
    const resp = await AreasServices.getArea(id);
    dispatch({
      type: actions.GET_AREA,
      payload: resp.data,
    });
    dispatch({
      type: actions.AREA_FAIL,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.AREA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_AREA,
      payload: false,
    });
  }
};

export const saveArea = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_AREA,
      payload: true,
    });

    const resp = await AreasServices.saveArea(req);
    const { areas } = getState().areasDescriptoresPerfiles;

    dispatch({
      type: actions.GET_AREAS,
      payload: {
        count: areas.count + 1,
        data: [...areas.data, resp.data],
      },
    });

    dispatch({
      type: actions.FORM_AREA_FAIL,
      payload: null,
    });

    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

    setShowModal(false);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FORM_AREA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_AREA,
      payload: false,
    });
  }
};

export const editArea =
  (req, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_AREA,
        payload: true,
      });
      const resp = await AreasServices.editArea(req.id, req);
      const { areas } = getState().areasDescriptoresPerfiles;
      let _areas = areas.data.slice();
      _areas[index] = resp.data;
      dispatch({
        type: actions.GET_AREAS,
        payload: {
          count: areas.count,
          data: _areas,
        },
      });
      dispatch({
        type: actions.FORM_AREA_FAIL,
        payload: null,
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      setShowModal(false);
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORM_AREA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_AREA,
        payload: false,
      });
    }
  };

export const deleteArea = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_AREAS,
      payload: true,
    });
    await AreasServices.deleteArea(id);
    const { areas } = getState().areasDescriptoresPerfiles;
    let _areas = areas.data.slice();
    _areas.splice(index, 1);
    dispatch({
      type: actions.GET_AREAS,
      payload: {
        data: _areas,
        count: areas.count - 1,
      },
    });
    dispatch({
      type: actions.AREAS_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.AREAS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_AREAS,
      payload: false,
    });
  }
};
